<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        <!-- MIS XV ESQUINA SUPERIOR IZQUIERDA -->
        <div class="mis-xv-wrapper-fixed">
          <img
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img"
          >
          <div
            ref="misXvTopRef"
            class="mis-xv-top glowing"
          >
            MIS XV
          </div>
        </div>

        <!-- Nombre -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
          Dayra Janeth
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const misXvTopRef = ref(null)
    let ctx

    onMounted(() => {
      // gsap.context limpia automáticamente referencias y triggers en Vue
      ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: fotoPortadaRef.value,
            start: 'top 80%',
            once: true
          }
        })

        // 1. Revelado elegante del fondo (Blur, Escala y Fade)
        tl.fromTo(
          fotoPortadaRef.value,
          {
            autoAlpha: 0,
            scale: 1.05,
            filter: 'blur(10px)'
          },
          {
            autoAlpha: 1,
            scale: 1,
            filter: 'blur(0px)',
            duration: 1.4,
            ease: 'power3.out'
          }
        )

        // 2. Entrada fluida de la Corona y "MIS XV"
        .fromTo(
          misXvTopRef.value.parentElement,
          {
            autoAlpha: 0,
            y: -25,
            scale: 0.9
          },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1,
            ease: 'back.out(1.4)'
          },
          '-=0.8' // Solapamiento para fluidez
        )

        // 3. Aparición estilizada del Nombre con efecto de enfoque
        .fromTo(
          nombreRef.value,
          {
            autoAlpha: 0,
            y: 35,
            filter: 'blur(8px)'
          },
          {
            autoAlpha: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.2,
            ease: 'power4.out'
          },
          '-=0.6'
        )
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert() // Liberar recursos de memoria
    })

    return {
      fotoPortadaRef,
      nombreRef,
      misXvTopRef
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* ================= CONTENEDOR FOTO ================= */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: 0px;
  background-image:
    linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.45)),
    url('@/assets/Copia de EEE2952EE_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 1;
  will-change: transform, opacity, filter;

  box-shadow:
    0 -40px 80px rgba(255,255,255,0.2) inset,
    0 20px 40px rgba(0,0,0,0.3);
}

/* ================= OVERLAY ================= */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  color: white;
  z-index: 2;
  padding-bottom: 60px;
  box-sizing: border-box;
}

/* ================= MIS XV ================= */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: 25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
  will-change: transform, opacity;
}

.ornamento-img {
  width: 38px;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file', sans-serif;
  font-size: 18px;
  letter-spacing: 1.5px;
  color: white;
}

.glowing {
  animation: glow 3s ease-in-out infinite alternate;
}

@keyframes glow {
  from { text-shadow: 0 0 4px rgba(255,255,255,0.4); }
  to   { text-shadow: 0 0 14px rgba(255,255,255,0.9); }
}

/* ================= NOMBRE ================= */
.centered-text {
  font-size: Clamp(55px, 10vw, 55px) !important;
  font-weight: 200;
  text-align: center;
  
  /* 🔥 MOVER MÁS ARRIBA: Ajusta este translateY o margin-bottom según prefieras */
  transform: translateY(-80px); 
  margin-bottom: 40px; 
  
  line-height: 1.2;
  padding: 0 20px;
  font-family: 'ludovica', serif !important;
  color: #ffffff;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  will-change: transform, opacity, filter;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

@media (max-width: 768px) {
  .mis-xv-wrapper-fixed {
    top: 15px;
    left: 15px;
  }
}
</style>